namespace TabAurous.ECommerce {
    export interface PickUpForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        Address: Serenity.TextAreaEditor;
        CountryId: Serenity.LookupEditor;
        StateId: Serenity.LookupEditor;
        CityId: Serenity.LookupEditor;
        Pin: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        FreightId: Serenity.LookupEditor;
        PickupDate: Serenity.DateEditor;
        PickupTime: Serenity.TimeEditor;
        LabelId: Serenity.StringEditor;
        AWBNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: PickUpItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        ReceiptAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class PickUpForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.PickUp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PickUpForm.init)  {
                PickUpForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.TimeEditor;
                var w7 = s.DecimalEditor;
                var w8 = PickUpItemsEditor;

                Q.initFormType(PickUpForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'POSCustomerId', w3,
                    'Address', w4,
                    'CountryId', w5,
                    'StateId', w5,
                    'CityId', w5,
                    'Pin', w1,
                    'PartyId', w2,
                    'FreightId', w5,
                    'PickupDate', w0,
                    'PickupTime', w6,
                    'LabelId', w1,
                    'AWBNumber', w1,
                    'CustomerName', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w5,
                    'ExchRate', w7,
                    'UserId', w5,
                    'EmployeeId', w2,
                    'ItemDetails', w8,
                    'FinancialYearId', w2,
                    'Pieces', w2,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'ReceiptAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'GrossAmount', w7,
                    'Remark', w4,
                    'ShipAddressId', w2,
                    'CompanyId', w2,
                    'ShipmentId', w2
                ]);
            }
        }
    }
}
